import { useState } from "react";
import { HomePage } from "./home/HomePage";
import FieldServiceApp from "./field-service/FieldServiceApp";
import CmmsApp from "./cmms/CmmsApp";
import CustomerPortalApp from "./customer-portal/CustomerPortalApp";
import type { RootView } from "./shared/productTypes";

// Only the main branch's deployment shows the Home picker — every other
// branch preview (Cloudflare sets __CF_PAGES_BRANCH__ automatically for
// every build, no per-branch config needed) boots straight into a product
// so the branch's feature is front and center. Local dev (where
// __CF_PAGES_BRANCH__ is empty) always shows Home. Branches with "cmms" in
// their name default to CMMS; everything else non-main defaults to Field
// Service. A branch can still override with a VITE_DEFAULT_VIEW build env
// var if neither guess fits (e.g. a Customer Portal branch).
const onNonMainBranchDeploy = __CF_PAGES_BRANCH__ !== "" && __CF_PAGES_BRANCH__ !== "main";
const branchDefaultView: RootView = __CF_PAGES_BRANCH__.toLowerCase().includes("cmms") ? "cmms" : "field-service";
const DEFAULT_VIEW: RootView =
  (import.meta.env.VITE_DEFAULT_VIEW as RootView | undefined) ?? (onNonMainBranchDeploy ? branchDefaultView : "home");

export default function App() {
  const [view, setView] = useState<RootView>(DEFAULT_VIEW);

  if (view === "field-service") {
    return <FieldServiceApp onNavigateRoot={setView} />;
  }
  if (view === "cmms") {
    return <CmmsApp onNavigateRoot={setView} />;
  }
  if (view === "customer-portal") {
    return <CustomerPortalApp onNavigateRoot={setView} />;
  }
  return (
    <HomePage
      onOpenFieldService={() => setView("field-service")}
      onOpenCmms={() => setView("cmms")}
    />
  );
}
